var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"btn btn-secondary",class:{ 'btn-loading': _vm.loading, 'btn-lg': !_vm.inline, 'w-100': !_vm.inline },attrs:{"type":_vm.type,"disabled":_vm.disabled||_vm.loading}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }